import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import { Paper } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import '../../styles/dashboard/Announcements.css';
import LatestAnnouncements from '../../components/dashboard/announcements/LatestAnnouncements';
import PastAnnouncements from '../../components/dashboard/announcements/PastAnnouncements';
import TablePastShort from '../../components/dashboard/announcements/TablePastShort';
import TableLatestShort from '../../components/dashboard/announcements/TableLatestShort';
import AddNewForm from '../../components/dashboard/announcements/AddNewForm';
import DetailsPage from '../../components/dashboard/announcements/DetailsPage';
import SignClose from '../../components/dashboard/announcements/SignClose';
import AntSwitch from '../../components/common/AntSwitch';
import FilterMenu from '../../components/common/FilterMenu';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    position: 'relative',
    '& .tables': {
      width: '100%'
    },
    '& .add-pane': {
      display: 'none',
      width: '100%',
      padding: '32px 40px !important',

      '& .MuiFormControl-root': {
        // width: '100%'
      },

      '& .header': {
        position: 'relative',
        marginBottom: '8px',
        '& .close': {
          position: 'absolute',
          right: 0,
          color: '#7F68DD',
          fontWeight: 500,
          cursor: 'pointer'
        }
      }
    },

    '&.show-add': {
      '& .tables': {
        width: '50%',
        maxWidth: '394px',
        marginRight: '24px',
        minWidth: '350px'
      },
      '& .add-pane': {
        display: 'block'
      }
    },

    '& .MuiExpansionPanel-root': {
      padding: '0 !important',
      margin: '0 !important',
      boxShadow: 'none !important',
      '&:before': {
        display: 'none'
      },

      '& .MuiCollapse-container.MuiCollapse-entered': {
        marginTop: '-40px'
      },
      '& .MuiExpansionPanelSummary-root': {
        padding: '0',

        '&[aria-expanded="false"] svg': {
          transform: 'rotate(-90deg)'
        }
      },

      '& .MuiExpansionPanelDetails-root': {
        padding: '0'
      }
    }
  },
  addNewButton: {
    '& .main-button': {
      bordertopLeftRadius: '4px',
      borderbottomLeftRadius: '4px',
      borderRight: 'none',
      backgroundColor: '#434343',
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: 500,
      height: 40
    },
    '& .more-button': {
      bordertopRightRadius: '4px',
      borderbottomRightRadius: '4px',
      borderLeft: 'none',
      backgroundColor: '#434343',
      color: '#FFFFFF',
      fontSize: '12px',
      fontWeight: 500,
      height: 40
    }
  },
  menuItem: {
    '&.MuiListItem-button:hover': {
      textDecoration: 'none',
      backgroundColor: '#434343',
      color: '#FFFFFF'
    }
  },
  formControl: {
    display: 'inline-block',
    minWidth: '150px',
    marginRight: '0px',
    '& .MuiInputBase-root': {
      width: '100%',
      '&:after': {
        display: 'none !important'
      },
      '&:before': {
        border: 'none !important'
      }
    }
  }
});
const options = ['Announcements', 'Memo'];

const Announcements = () => {
  const filterByDateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Upcoming', value: 'upcoming' },
    { label: 'Overdue', value: 'overdue' }
  ];
  const filterByTaskOptions = [
    { label: 'Urgent', value: 'urgent' },
    { label: 'Important', value: 'important' },
    { label: 'Normal', value: 'normal' },
    { label: 'Complaints', value: 'complaints' },
    { label: 'Closed', value: 'closed' }
  ];
  const filterByDepartmentsOption = [
    { label: 'Front Desk', value: 'front-Desk' },
    { label: 'Housekeeping', value: 'housekeeping' }
  ];

  const classes = useStyles();
  const [pane, setPane] = useState(0);
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [showLatest, setShowLatest] = useState(true);
  const [showPast, setShowPast] = useState(true);
  const [showLatestShortOpen, setShowLatestShortOpen] = useState(true);
  const [showPastShortOpen, setShowPastShortOpen] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [addNewForm, setAddNewForm] = useState(false);
  const [readDetails, setReadDetails] = useState(false);
  const [detailsID, setDetailsID] = useState(null);
  const [signClose, setSignClose] = useState(false);

  const [filters, setFilters] = useState({
    date: null,
    task: null,
    department: null,
    private: false
  });
  const filterChange = (name, value) => {
    setFilters({ ...filters, [name]: value });
  };

  const [toggled, setToggled] = useState({ checked: false });

  const handleToggleChange = (event) => {
    setToggled({ ...toggled, checked: event.target.checked });
  };

  const handleMenuItemClick = (event, index) => {
    setPane(index);
    setOpen(false);
    setFormOpen(true);
    setAddNewForm(true);
    setSignClose(false);
    setReadDetails(false);
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <div className='main-section'>
      {!formOpen && (
        <>
          <div className='announcements-head d-flex justify-content-between align-items-center'>
            <p className='main-title my-0'>Announcements & Memo</p>

            <div className='d-flex justify-content-between align-items-center'>
              <div className='filters'>
                <FilterMenu
                  value={filters.date}
                  onChange={(e) => filterChange('date', e)}
                  options={filterByDateOptions}
                  placeholder='Filter Date'
                />
                <FilterMenu
                  value={filters.task}
                  onChange={(e) => filterChange('task', e)}
                  options={filterByTaskOptions}
                  placeholder='Filter Task'
                />
                <FilterMenu
                  value={filters.department}
                  onChange={(e) => filterChange('department', e)}
                  options={filterByDepartmentsOption}
                  placeholder='All Departments'
                />

                <FormControl className={classes.formControl}>
                  <Typography component='div' style={{ marginRight: '40px' }}>
                    <Grid
                      component='label'
                      container
                      alignItems='center'
                      spacing={1}
                    >
                      <Grid item>
                        <span className='toggle-label'>My Department</span>
                      </Grid>
                      <Grid item>
                        <AntSwitch
                          checked={toggled.checked}
                          onChange={handleToggleChange}
                          name='checked'
                        />
                      </Grid>
                    </Grid>
                  </Typography>
                </FormControl>
              </div>

              <div>
                <ButtonGroup
                  ref={anchorRef}
                  aria-label='split button'
                  className={classes.addNewButton}
                >
                  <Button className='main-button' onClick={handleToggle}>
                    Add New
                  </Button>
                  <Button
                    size='small'
                    className='more-button'
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label='select merge strategy'
                    aria-haspopup='menu'
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon></ArrowDropDownIcon>
                  </Button>
                </ButtonGroup>
                <Popper
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'bottom'
                            ? 'center top'
                            : 'center bottom'
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList id='split-button-menu'>
                            {options.map((option, index) => (
                              <MenuItem
                                className={classes.menuItem}
                                key={option}
                                onClick={(event) =>
                                  handleMenuItemClick(event, index)
                                }
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </div>
          </div>

          {/* Announcement Table */}
          <div className='announcement-tables'>
            <hr className='main-devider' />
            <div className='latest-announcement'>
              <p className='announcement-table-head m-0'>
                {showLatest === false ? (
                  <ArrowDropUpIcon
                    className='aria-expand-btn'
                    fontSize='large'
                    onClick={() => setShowLatest(true)}
                  />
                ) : (
                  <ArrowDropDownIcon
                    className='aria-expand-btn'
                    fontSize='large'
                    onClick={() => setShowLatest(false)}
                  />
                )}
                Latest{' '}
              </p>
              {showLatest && (
                <LatestAnnouncements
                  setReadDetails={setReadDetails}
                  setDetailsID={setDetailsID}
                  setFormOpen={setFormOpen}
                  setSignClose={setSignClose}
                  setAddNewForm={setAddNewForm}
                />
              )}
            </div>
            <div className='past-announcement mb-4'>
              <p className='announcement-table-head m-0'>
                {showPast === false ? (
                  <ArrowDropUpIcon
                    className='aria-expand-btn'
                    fontSize='large'
                    onClick={() => setShowPast(true)}
                  />
                ) : (
                  <ArrowDropDownIcon
                    className='aria-expand-btn'
                    fontSize='large'
                    onClick={() => setShowPast(false)}
                  />
                )}
                Past{' '}
              </p>
              {showPast && <PastAnnouncements />}
            </div>
          </div>
        </>
      )}

      {formOpen && (
        <>
          <div className='d-flex mb-4'>
            <div className='half-tables p-4 mr-2'>
              <p className='main-title-short my-0'>Announcements & Memo</p>
              <hr className='short-devider' />
              <div className='latest-announcement'>
                <p className='announcement-table-head m-0'>
                  {showLatestShortOpen === false ? (
                    <ArrowDropUpIcon
                      className='aria-expand-btn'
                      fontSize='large'
                      onClick={() => setShowLatestShortOpen(true)}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      className='aria-expand-btn'
                      fontSize='large'
                      onClick={() => setShowLatestShortOpen(false)}
                    />
                  )}
                  Latest{' '}
                </p>
                {showLatestShortOpen && (
                  <TableLatestShort
                    setReadDetails={setReadDetails}
                    setDetailsID={setDetailsID}
                    setFormOpen={setFormOpen}
                    setSignClose={setSignClose}
                    setAddNewForm={setAddNewForm}
                  />
                )}
              </div>
              <div className='past-announcement'>
                <p className='announcement-table-head m-0'>
                  {showPastShortOpen === false ? (
                    <ArrowDropUpIcon
                      className='aria-expand-btn'
                      fontSize='large'
                      onClick={() => setShowPastShortOpen(true)}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      className='aria-expand-btn'
                      fontSize='large'
                      onClick={() => setShowPastShortOpen(false)}
                    />
                  )}
                  Past{' '}
                </p>
                {showPastShortOpen && <TablePastShort />}
              </div>
            </div>

            <div className='forms-section'>
              {addNewForm && (
                <AddNewForm setFormOpen={setFormOpen} pane={pane} />
              )}
              {readDetails && (
                <DetailsPage
                  detailsID={detailsID}
                  setFormOpen={setFormOpen}
                  setSignClose={setSignClose}
                  setReadDetails={setReadDetails}
                  setAddNewForm={setAddNewForm}
                />
              )}
              {signClose && (
                <SignClose
                  setFormOpen={setFormOpen}
                  setAddNewForm={setAddNewForm}
                  detailsID={detailsID}
                  setReadDetails={setReadDetails}
                  setSignClose={setSignClose}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default withRouter(Announcements);
